var exports = {
  "z": "x93eb46d8--803a86--root",
};

module.exports = exports;
